module.exports = __webpack_public_path__ + "static/media/Logo.7a9cc6da.png";